//@flow
import type { CountryType } from '../../../config/iddCountries';

export type TravelActionType = {|
  type: 'SET_TRAVEL_COUNTRY',
  payload: {|
    country: CountryType,
  |},
|};

export const setTravelCountry = (country: CountryType): TravelActionType => ({
  type: 'SET_TRAVEL_COUNTRY',
  payload: { country },
});
